export const TrustAndSafety = () => (
  <div className="min-h-screen bg-white py-16">
    <div className="max-w-4xl mx-auto px-6">
      <h1 className="text-4xl font-semibold text-[#1A1A1A] mb-8 font-['Outfit']" data-testid="trust-safety-title">Trust & Safety</h1>
      <div className="space-y-6 text-[#6B7280]">
        <p>At Cape Town Monthly, we verify every property listing to ensure the safety and trust of our community.</p>
        <h2 className="text-2xl font-medium text-[#005B99] mt-8 font-['Outfit']">Verification Process</h2>
        <p>Every host must submit a walkthrough video of their property. Our team manually reviews each video within 24 hours to ensure the property exists and matches the description.</p>
        <h2 className="text-2xl font-medium text-[#005B99] mt-8 font-['Outfit']">Verified Badge</h2>
        <p>Only properties that pass our verification receive the Verified badge, giving guests confidence in their rental choice.</p>
      </div>
    </div>
  </div>
);
